export const TEMPLATES_SORTING_NAME = 'name'
export const TEMPLATES_SORTING_CREATION = 'creation'
export const TEMPLATES_SORTING_CREATED_AT = 'createdAt'
